import React, { Component } from "react";
import { formFeildStyle } from "../../../../wigets/forms/style/formFields";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { Col, Row } from "reactstrap";
import { languageService } from "../../../../Language/language.service";
import { locationListStyle } from "../../../LocationSetup/LocationListStyle";
import SvgIcon, { Icon } from "react-icons-kit";
import { cross } from "react-icons-kit/icomoon/cross";
import { checkboxChecked } from "react-icons-kit/icomoon/checkboxChecked";
import { checkboxUnchecked } from "react-icons-kit/icomoon/checkboxUnchecked";
export const freqObj = {
  freq: 1,
  timeFrame: "Year",
  timeFrameNumber: 1,
  recurNumber: 1,
  recurTimeFrame: "Year",
  maxInterval: 0,
  minDays: 0,
  ignoreCalendarBoundary: false,
};

export default class InspectionFreqRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      freqObj: this.props.freqObject ? this.props.freqObject : freqObj,
    };

    this.changeHandler = this.changeHandler.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.freqObject !== this.props.freqObject) {
      this.setState({
        freqObj: this.props.freqObject,
      });
    }
  }

  changeHandler(e, blur) {
    let freqObj = { ...this.state.freqObj };
    freqObj[e.target.name] = e.target.value;
    if (blur) {
      // TODO : validation on blur
    } else {
      // TODO : basic validation
    }
    this.setState({
      freqObj: freqObj,
    });
    this.props.frequenciesChangeHandler(freqObj, this.props.rowIndex);
  }
  render() {
    return (
      <div>
        <div
          style={{
            border: "1px solid rgb(177, 177, 177)",
            padding: "10px",
            width: "auto",
          }}
        >
          <div>
            <LabelWithFieldWrapper label={languageService("Inspection Frequency")}>
              <InputField
                inputFieldProps={{ name: "freq", type: "number", min: 0 }}
                changeHandler={this.changeHandler}
                value={this.state.freqObj.freq}
                error={this.props.inspectionFreqValidtion.freq.required}
                message={this.props.inspectionFreqValidtion.freq.message}
              />
            </LabelWithFieldWrapper>
            <InputField
              inputFieldProps={{ name: "timeFrameNumber", label: languageService("in"), type: "number", min: 0 }}
              changeHandler={this.changeHandler}
              value={this.state.freqObj.timeFrameNumber}
              error={this.props.inspectionFreqValidtion.timeFrameNumber.required}
              message={this.props.inspectionFreqValidtion.timeFrameNumber.message}
            />
            <SelectField
              inputFieldProps={{ name: "timeFrame" }}
              options={[...timeFrameOptions]}
              changeHandler={this.changeHandler}
              value={this.state.freqObj.timeFrame}
            />
            <InputField
              inputFieldProps={{ name: "recurNumber", label: languageService("every"), type: "number", min: 0 }}
              changeHandler={this.changeHandler}
              value={this.state.freqObj.recurNumber}
              error={this.props.inspectionFreqValidtion.recurNumber.required}
              message={this.props.inspectionFreqValidtion.recurNumber.message}
            />
            <SelectField
              inputFieldProps={{ name: "recurTimeFrame" }}
              options={[...timeFrameOptions]}
              changeHandler={this.changeHandler}
              value={this.state.freqObj.recurTimeFrame}
            />

            {this.props.rowIndex > 0 && (
              <span
                id={`freqId-${this.props.rowIndex}`}
                onClick={(e) => {
                  this.props.frequenciesChangeHandler(this.state.freqObj, this.props.rowIndex, true);
                }}
                style={{
                  ...themeService(locationListStyle.saveInputIcon),
                  ...{ color: "#840f0f", float: "none", padding: "0px 7px", height: "auto" },
                }}
              >
                <SvgIcon style={{ verticalAlign: "middle" }} icon={cross} size="15" />
              </span>
            )}
          </div>
          <div>
            <InputField
              inputFieldProps={{ name: "minDays", label: languageService("Days between Inspections"), type: "number", min: 0 }}
              changeHandler={this.changeHandler}
              value={this.state.freqObj.minDays}
              style={{ minWidth: "50%" }}
              error={this.props.inspectionFreqValidtion.minDays.required}
              message={this.props.inspectionFreqValidtion.minDays.message}
            />

            <div style={{ display: "flex" }}>
              <div>
                <InputField
                  inputFieldProps={{ name: "maxInterval", label: languageService("Max Interval"), type: "number", min: 0 }}
                  changeHandler={this.changeHandler}
                  value={this.state.freqObj.maxInterval}
                  error={this.props.inspectionFreqValidtion.maxInterval.required}
                  message={this.props.inspectionFreqValidtion.maxInterval.message}
                />
              </div>

              {
                <div
                  style={{ marginLeft: "5px" }}
                  className="asset-check-box"
                  onClick={(e) =>
                    this.changeHandler({ target: { name: "ignoreCalendarBoundary", value: !this.state.freqObj.ignoreCalendarBoundary } })
                  }
                >
                  <Icon icon={this.state.freqObj.ignoreCalendarBoundary ? checkboxChecked : checkboxUnchecked} size={20} />
                  <span style={{ marginLeft: "2px" }}> {languageService("Ignore calendar boundary")}</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const InputField = (props) => {
  return (
    <div
      style={{
        ...props.style,
        ...themeService(formFeildStyle.feildStyle),
        display: "inline-flex",
        margin: "0px 0px 15px 0px",
        alignItems: "baseline",
      }}
    >
      {props.inputFieldProps.label && (
        <label style={{ ...themeService(formFeildStyle.lblStyle), width: "inherit", margin: "0px 5px 5px" }}>
          {props.inputFieldProps.label + ":"}
        </label>
      )}
      <div>
        <input
          style={{ ...themeService(formFeildStyle.inputStyle), width: "inherit" }}
          disabled={props.inputFieldProps.disabled}
          onChange={(e) => props.changeHandler(e, false)}
          onBlur={(e) => props.changeHandler(e, true)}
          value={props.value}
          {...props.inputFieldProps}
          title=""
        />
        {props.error && (
          <p style={{ fontSize: "11px", marginBottom: "-12px", color: "red" }}>
            {props.message.length !== 0 ? props.message : "Field is Required"}
          </p>
        )}
      </div>
    </div>
  );
};

const SelectField = (props) => {
  return (
    <div style={{ ...themeService(formFeildStyle.feildStyle), display: "inline-block", margin: "0px 0px 15px 0px" }}>
      {props.label && (
        <label style={{ ...themeService(formFeildStyle.lblStyle), width: "inherit", margin: "0px 5px 5px" }}>
          {languageService(props.label) + ":"}
        </label>
      )}
      <select
        style={{ ...themeService(formFeildStyle.inputStyle), width: "inherit" }}
        onChange={(e) => props.changeHandler(e, false, "select")}
        onBlur={(e) => props.changeHandler(e, true, "select")}
        {...props.inputFieldProps}
        value={props.value}
      >
        {props.options &&
          props.options.map((item, index) => (
            <option key={index} value={item.val}>
              {languageService(item.text)}
            </option>
          ))}
      </select>
    </div>
  );
};

const timeFrameOptions = [
  { val: "Day", text: "Day" },
  { val: "Week", text: "Week" },
  { val: "Month", text: "Month" },
  { val: "Year", text: "Year" },
];

const LabelWithFieldWrapper = (props) => {
  return (
    <div style={{ display: "inline-block" }}>
      <div style={{ marginBottom: "5px", fontSize: "14px", fontWeight: 600 }}>{languageService(props.label)}</div>
      {props.children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/WorkPlanTemplate/JourneyPlanAddEdit/JourneyPlanFrequency/InspectionFreqRow.jsx